import CampaignItem from '../../../components/campaign/CampaignItem';
import HScrollContainer from '../../../layouts/HScrollContainer';

interface Props {
    items: []
}

const ActiveProjects: React.FC<Props> = (props) => {
    return <HScrollContainer>
        {props.items?.map((item: any) => {
            return <CampaignItem
                type="big"
                key={`campaign_${item.id}`}
                link={`/campaign/${item.id}`}
                id={item.id}
                title={item.title}
                image={item.image}
                currentPrice={item.donates}
                targetPrice={item.goal}
                progress={item.percentage}
                finalized={item.finalized}
                isPlanting={item.isPlanting}
                seedlings={item.seedlings} />
        })}
    </HScrollContainer>
}

export default ActiveProjects